import { AbstractFilterService } from './abstract-filter.service';
import { Injectable } from '@angular/core';
import {
    WkfSupervisionFilterAction
} from '../../wkf-supervision-search/wkf-supervision-filter/action/wkf-supervision-filter.action';
import {
    ProcessStateEnum
} from '../../wkf-supervision-search/wkf-supervision-filter/reducer/wkf-supervision-filter.reducer';

@Injectable( {
    providedIn: 'root'
} )
export class WkfSupervisionFilterService extends AbstractFilterService {
    constructor(private  wkfSupervisionFilterAction: WkfSupervisionFilterAction) {
        super();
    }

    protected getFilterAction(): WkfSupervisionFilterAction {
        return this.wkfSupervisionFilterAction;
    }

    changeProcessStateFilter( newProcessStateFilterValue: ProcessStateEnum ) {
        this.wkfSupervisionFilterAction.updateProcessStateFilterSucceed(newProcessStateFilterValue)
    }
}